const React = require("react");

const useId = require('@reach/auto-id').useId;

function DeniedCircleIcon(props, svgRef) {
  const id = "DeniedCircleIcon" + '_' + useId();
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zM9.446 8.397A.75.75 0 008.47 9.53L10.939 12l-2.47 2.47-.072.084a.75.75 0 001.133.976L12 13.061l2.47 2.47.084.072a.75.75 0 00.976-1.133L13.061 12l2.47-2.47.072-.084a.75.75 0 00-1.133-.976L12 10.939l-2.47-2.47z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(DeniedCircleIcon);
const MemoForwardRef = React.memo(ForwardRef);
module.exports = MemoForwardRef;